import React from 'react';
import styles from '../FindATempPageV2.module.scss';

interface ToggleSwitchProps {
    checked: boolean;
    onChange: (checked: boolean) => void;
    disabled?: boolean;
    ariaLabel: string;
    id?: string;
}

const ToggleSwitch: React.FC<ToggleSwitchProps> = ({ checked, onChange, disabled, ariaLabel, id }) => (
    <label className={styles.toggle}>
        <input
            id={id}
            type="checkbox"
            className={styles.toggleInput}
            checked={checked}
            onChange={(e) => onChange(e.target.checked)}
            disabled={disabled}
            aria-label={ariaLabel}
            role="switch"
        />
        <span className={styles.toggleSlider} />
    </label>
);

export default ToggleSwitch;
